import { defineStore } from 'pinia';
import { ref } from 'vue';

import { dashboardBffClient } from '@/api-client';
import type { AuthUser } from '@/api-client/api';

export const useUserStore = defineStore('user', () => {
  const authUser = ref<AuthUser>();

  function logOut() {
    authUser.value = undefined;
  }

  async function fetchAuthUser() {
    const { data } = await dashboardBffClient.authuser.getAuthUser();
    authUser.value = data;
  }

  return { logOut, authUser, fetchAuthUser };
});
